"use client";

import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section id="hero" className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/hero_bathroom_remodel_services.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/hero_bathroom_remodel_services.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/hero_bathroom_remodel_services.png-wvc-sizes" alt="Professional bathroom remodel services in Lakeland FL" className="w-full h-full object-cover object-center" loading="eager" />
        <div className="absolute inset-0 bg-background/90 backdrop-blur-[2px]"></div>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-6 py-24 md:py-32 text-center max-w-4xl">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="flex flex-col items-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground mb-6 tracking-tight text-balance">
            Bathroom Remodel Services in Lakeland, FL
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-3xl mx-auto leading-relaxed text-balance">
            Bathroom remodel services in Lakeland can include full bathroom renovations, shower remodels, tub replacements, tile, flooring, vanities, fixtures, lighting, storage, and layout improvements. Request a free quote to review your project details and next steps.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full sm:w-auto">
            <Link to="/ContactPage" className="w-full sm:w-auto">
              <Button size="lg" className="w-full sm:w-auto text-base h-14 px-8 shadow-md">
                Request a Free Quote
              </Button>
            </Link>
            <Link to="/BathroomRemodelPage" className="w-full sm:w-auto">
              <Button variant="outline" size="lg" className="w-full sm:w-auto text-base h-14 px-8 bg-background/50 backdrop-blur-md border-border shadow-sm hover:bg-accent">View Bathroom Remodel Page</Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}